import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';

import { PartnerSepaSettingsComponent } from './partner-sepa-settings.component';
import { RnplCommonModule } from 'common/src/modules';
import { UIComponentsModule } from 'common/src/modules';

@NgModule({
  declarations: [
    PartnerSepaSettingsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UIComponentsModule,
    TranslateModule,
    NgSelectModule,
    NgxMaskModule,
    RnplCommonModule,
  ],
  exports: [
    PartnerSepaSettingsComponent,
  ],
  providers: []
})
export class PartnerSepaSettingsModule { }
